import { render, staticRenderFns } from "./TruckFormModal.vue?vue&type=template&id=e4f6fe4a"
import script from "./TruckFormModal.vue?vue&type=script&lang=js"
export * from "./TruckFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports